import { ConsumptionFormValue, FormValues } from './types';

export const months = [
  'janeiro',
  'fevereiro',
  'marco',
  'abril',
  'maio',
  'junho',
  'julho',
  'agosto',
  'setembro',
  'outubro',
  'novembro',
  'dezembro',
] as const;

const defaultValue: ConsumptionFormValue['janeiro'] = {
  updatedAt: '',
  value: '',
};

export const defaultConsumptionFormValue: ConsumptionFormValue = {
  janeiro: defaultValue,
  fevereiro: defaultValue,
  marco: defaultValue,
  abril: defaultValue,
  maio: defaultValue,
  junho: defaultValue,
  julho: defaultValue,
  agosto: defaultValue,
  setembro: defaultValue,
  outubro: defaultValue,
  novembro: defaultValue,
  dezembro: defaultValue,
};

export const defaultFormValues: FormValues = {
  [new Date().getFullYear().toString()]: defaultConsumptionFormValue,
};

export const monthToNumber = (month: typeof months[number]): number => {
  const index = months.indexOf(month);
  return index >= 0 ? index + 1 : -1;
};

export const isFormChanged = (defaultValues: FormValues, values: FormValues): boolean => Object.entries(values).some(([key, value]) => Object.entries(value).some(([keyForm, valueForm]) => defaultValues[key]?.[keyForm]?.value !== valueForm.value));
